import {
    checkPerm,
    getDefaultContactGroup,
    getDefaultUserOfficeValues,
    getLookup,
    updateContractFields,
    updateStateFields
} from "../../../../common/util/util-helpers";
import {Field, FieldsManager} from "../../../../data/services/fields";
import FieldOptions from "../../../../common/components/fields/field-options";
import {InformationCircleIcon} from "@heroicons/react/24/outline";
import Resources from "../../../../data/services/resources";
import {
    DEFAULT_METADATA_SELECT_SEARCH_QUERY,
    FIELD_MASK_PHONE,
    READ_PERM,
    SCAC_CODE_FIELD_LENGTH
} from "../../../../util/util-constants";
import React, {useEffect, useState} from "react";
import FieldsForm from "../../../../common/components/fields/fields-form";
import {getCountryCodes} from "../../../../common/util/countryCodes";
import ModalFooter from "../../../../common/components/modal/modal-footer";
import LocalStorage from "../../../../util/localStorage";
import {scrollErrorIntoViewFields, setSelectionRange} from "../../../../common/util/util-vanilla";
import {useDispatch, useSelector} from "react-redux";
import {clearDialogResource, createDialogResource} from "../../../../data/actions/dialogResource";
import GroupsViewDialog from "../../../my-company/groups-view/groups-view-dialog";
import FieldSwitchLabel from "../../../../common/components/fields/field-switch/field-switch-label";

export default function VendorFormDialog({onClose, onSelectCreatedVendor, MakeMCDOTAndAddressRequired, translate}) {
    const dispatch = useDispatch();
    const [isStateDirty, setIsStateDirty] = useState(false);


    const [fields, setFields] = useState(() => getFields(undefined, MakeMCDOTAndAddressRequired));
    const [isGroupInfoDialogOpen, setIsGroupInfoDialogOpen] = useState(false);
    const [groupInfoData, setGroupInfoData] = useState({});

    const selects = {
        AreaCode: getCountryCodes(),
        PhysicalStateID: getLookup('State'),
        PhysicalCountryID: getLookup('Country'),
        PhysicalPostalCode: getCountryCodes()
    }
    const dialogResource = useSelector(state => state.dialogResource);
    const isLoading = dialogResource?.isLoading;

    function submit() {
        const validFields = FieldsManager.validateFields(fields);

        if (FieldsManager.checkFieldsForErrors(validFields)) {
            const params = FieldsManager.getFieldKeyValues(validFields);

            if (params.PhysicalSameAsMailingAddress) {
                params.PhysicalAddressName = params.AddressName;
                params.PhysicalAddressName2 = params.AddressName2;
                params.PhysicalCityName = params.CityName;
                params.PhysicalStateID = params.StateID;
                params.PhysicalPostalCode = params.PostalCode;
            }

            dispatch(createDialogResource({
                user: LocalStorage.get('user'),
                params: params,
                resource: Resources.Vendors,
                errorMessage: true
            }))
        } else {
            scrollErrorIntoViewFields([validFields]);
            setFields(validFields);
        }
    }

    function handleInputChange(name, value) {
        let fieldsUpdate = FieldsManager.updateField(fields, name, value);

        fieldsUpdate = updateContractFields(fieldsUpdate, name, value);
        fieldsUpdate = updateStateFields(fieldsUpdate, name, value);

        if (name === 'PhysicalSameAsMailingAddress') {
            const isHidden = !!value;
            const physicalValidate = !isHidden && MakeMCDOTAndAddressRequired ? ['empty'] : [];
            fieldsUpdate.PhysicalCountryID.type = isHidden ? 'hidden' : 'select';
            fieldsUpdate.PhysicalGooglePlaces.type = isHidden ? 'hidden' : 'google-locations';
            fieldsUpdate.PhysicalAddressName.type = isHidden ? 'hidden' : 'text';
            fieldsUpdate.PhysicalAddressName2.type = isHidden ? 'hidden' : 'text';
            fieldsUpdate.PhysicalCityName.type = isHidden ? 'hidden' : 'text';
            fieldsUpdate.PhysicalStateID.type = isHidden ? 'hidden' : 'select';
            fieldsUpdate.PhysicalPostalCode.type = isHidden ? 'hidden' : 'text';
            fieldsUpdate.PhysicalAddressName.validate = physicalValidate;
            fieldsUpdate.PhysicalCityName.validate = physicalValidate;
            fieldsUpdate.PhysicalStateID.validate = physicalValidate;
            fieldsUpdate.PhysicalPostalCode.validate = physicalValidate;

            if (isHidden) {
                fieldsUpdate.PhysicalCountryID.value = "1";
                fieldsUpdate.PhysicalGooglePlaces.metadata.resetKey = (fieldsUpdate.PhysicalGooglePlaces.metadata.resetKey ?? 0) + 1;
                fieldsUpdate.PhysicalAddressName.value = '';
                fieldsUpdate.PhysicalAddressName2.value = '';
                fieldsUpdate.PhysicalCityName.value = '';
                fieldsUpdate.PhysicalStateID.value = '';
                fieldsUpdate.PhysicalPostalCode.value = '';
                fieldsUpdate.PhysicalAddressName.errorMessage = null;
                fieldsUpdate.PhysicalCityName.errorMessage = null;
                fieldsUpdate.PhysicalStateID.errorMessage = null;
                fieldsUpdate.PhysicalPostalCode.errorMessage = null;
            }
        }

        setIsStateDirty(true);
        setFields(fieldsUpdate);
    }

    function handleSetLocations(locationFields, isLocationPhysical = false) {
        let updatedFields = Object.assign({}, fields);

        for (let [key, value] of Object.entries(locationFields)) {
            if (isLocationPhysical) {
                key = "Physical" + key;
            }

            if (key in updatedFields) {
                if (!(key === 'LegalName' && !!updatedFields?.['LegalName']?.value)) {
                    updatedFields = FieldsManager.updateField(updatedFields, key, value)
                }
            }
        }

        setFields(updatedFields);
        setIsStateDirty(true);
    }


    function handleGroupInfoClick(groupData) {
        setIsGroupInfoDialogOpen(true);
        setGroupInfoData(groupData);
    }

    function getFields(item, required = false) {

        // const LegalName = getPreFillFromQuery() // Should be ITEM function parameter

        return {
            // Card 1
            CountryID: new Field('CountryID', "1", [], false, 'select', {
                addContainerClass: "col-span-full",
            }),
            GooglePlaces: new Field('GooglePlaces', '', [], false, 'google-locations', {
                setLocations: handleSetLocations,
                addContainerClass: "col-span-full"
            }),
            LegalName: new Field('LegalName', item?.LegalName ?? '', ['empty'], false, "text", {addContainerClass: "col-span-6"}),
            DBAName: new Field('DBAName', '', [''], false, "text", {addContainerClass: "col-span-6"}),
            AddressName: new Field('AddressName', '', required ? ['empty'] : [], false, "text", {addContainerClass: "col-span-full"}),
            AddressName2: new Field('AddressName2', '', [], false, "text", {addContainerClass: "col-span-full"}),
            CityName: new Field('CityName', '', required ? ['empty'] : [], false, "text", {addContainerClass: "col-span-4"}),
            StateID: new Field('StateID', '', required ? ['empty'] : [], false, 'select', {addContainerClass: "col-span-4"}, {menuPlacement: "top"}),
            PostalCode: new Field('PostalCode', '', required ? ['empty'] : [], false, "text", {addContainerClass: "col-span-4"}),

            PhysicalSameAsMailingAddress: new Field('PhysicalSameAsMailingAddress', 1, [], false, 'switch', {
                addContainerClass: "pr-4 col-span-full flex items-center rounded-xl bg-inverse shadow-sm border border-tm-gray-300",
                htmlBefore: () =>
                    <FieldSwitchLabel
                        label={translate("field.PhysicalSameAsMailingAddress")}
                    />
            }),
            PhysicalCountryID: new Field('PhysicalCountryID', "1", [], false, item?.PhysicalSameAsMailingAddress !== 0 ? 'hidden' : 'select', {
                addContainerClass: "col-span-full",
            }),
            PhysicalGooglePlaces: new Field('PhysicalGooglePlaces', '', [], false, item?.PhysicalSameAsMailingAddress !== 0 ? 'hidden' : 'google-locations', {
                setLocations: (fields) => handleSetLocations(fields, true),
                countryKey: "PhysicalCountryID",
                addContainerClass: "col-span-full",
            }),
            PhysicalAddressName: new Field('PhysicalAddressName', '', [], false, item?.PhysicalSameAsMailingAddress !== 0 ? 'hidden' : 'text', {
                addContainerClass: "col-span-full",
            }),
            PhysicalAddressName2: new Field('PhysicalAddressName2', '', [], false, item?.PhysicalSameAsMailingAddress !== 0 ? 'hidden' : 'text', {
                addContainerClass: "col-span-full",
            }),
            PhysicalCityName: new Field('PhysicalCityName', '', [], false, item?.PhysicalSameAsMailingAddress !== 0 ? 'hidden' : 'text', {
                addContainerClass: "col-span-4",
            }),
            PhysicalStateID: new Field('PhysicalStateID', '', [], false, item?.PhysicalSameAsMailingAddress !== 0 ? 'hidden' : 'select', {
                addContainerClass: "col-span-4",
            }, {menuPlacement: "top"}),
            PhysicalPostalCode: new Field('PhysicalPostalCode', '', [], false, item?.PhysicalSameAsMailingAddress !== 0 ? 'hidden' : 'text', {
                addContainerClass: "col-span-4",
            }),

            ContactGroupID: new Field('ContactGroupID',
                getDefaultContactGroup() ? getDefaultContactGroup() : null,
                ['empty'], false, 'select-search',
                {
                    addContainerClass: "col-span-full xl:col-span-6",
                    label: "CompaniesGroupID",
                    fieldOptions: (it) => {
                        return (
                            <FieldOptions
                                options={[
                                    {
                                        icon: InformationCircleIcon,
                                        onClick: () => handleGroupInfoClick(it?.value?.metadata),
                                        isVisible: !!it.value && checkPerm(Resources.ContactGroups, READ_PERM)
                                    }
                                ]}
                            />
                        )
                    }
                }, {
                    isClearable: true,
                    api: 'api/' + Resources.ContactGroupsQuick,
                    query: {},
                    searchMap: (it) => ({
                        label: it.ContactGroupName,
                        value: it.ContactGroupID,
                        metadata: it
                    })
                }
            ),

            OfficeID: new Field('OfficeID', getDefaultUserOfficeValues(), ['empty'], false, 'select-search',
                {
                    addContainerClass: "col-span-full xl:col-span-6",
                }, {
                    api: 'api/' + Resources.OfficesQuick,
                    query: DEFAULT_METADATA_SELECT_SEARCH_QUERY(),
                    searchMap: (item) => ({
                        label: item.OfficeName,
                        value: item.OfficeID
                    })
                }
            ),

            UserDefinedField1: new Field('UserDefinedField1', '', [], false, "test", {addContainerClass: "col-span-full"}),
            UserDefinedField2: new Field('UserDefinedField2', '', [], false, "test", {addContainerClass: "col-span-full"}),

            // Card 2
            AreaCode: new Field('AreaCode', '', [], false, 'select', {
                addContainerClass: "col-span-2"
            }),
            PhoneNumber: new Field('PhoneNumber', '', [''], false, 'mask', {}, {
                showMask: true,
                mask: FIELD_MASK_PHONE
            }),
            PhoneExtension: new Field('PhoneExtension', '', []),
            PrimaryEmail: new Field('PrimaryEmail', '', ['']),
            SCAC: new Field('SCAC', '', [''], false, 'text', {}, {
                max: SCAC_CODE_FIELD_LENGTH,
                upperCaseOnly: true
            }),
            OrganizationEntityTypeID: new Field('OrganizationEntityTypeID', '', [''], false, 'select', {
                addContainerClass: "col-span-2"
            }),
            MCNumber: new Field('MCNumber', '', required ? ['empty'] : [''], false, 'text', {label: 'MCMXNumber'}, {
                max: 10,
            }),
            FFNumber: new Field('FFNumber', '', [''], false, 'text', {}, {
                max: 10,
            }),
            USDOTNumber: new Field('USDOTNumber', '', [''], false, 'text', {}, {
                max: 10,
            }),
            FederalID: new Field('FederalID', '', [''], false, 'mask', {}, {
                showMask: true,
                mask: [/\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
                onFocus: (event) => {
                    setSelectionRange('FederalID', event.target.value)
                }
            }),
            NaicsID: new Field('NaicsID', '', [''], false, 'select'),
            SendPromotionalEmails: new Field('SendPromotionalEmails', 1, [], false, 'checkbox'),

            // Card 3
            Notes: new Field('Notes', '', [], false, 'textarea', {addContainerClass: 'col-span-full'}),

            // Card 4
            ContractOnFile: new Field('ContractOnFile', '', [], false, 'checkbox'),
            ContractStartDate: new Field('ContractStartDate', '', [''], true, 'date', {label: "CompanyContractStartDate"}, {}),
            ContractEndDate: new Field('ContractEndDate', '', [''], true, 'date', {}, {}),
            ContactNumber: new Field('ContactNumber', '', [''], true),
        }
    }

    useEffect(() => {
        if (dialogResource?.create?.VendorID) {
            const vendor = FieldsManager.getFieldKeyValues(fields);
            vendor.VendorID = dialogResource?.create?.VendorID;
            vendor.OrganizationID =  dialogResource?.create?.OrganizationID;
            onSelectCreatedVendor(vendor);
            dispatch(clearDialogResource());
        }
    }, [dialogResource]);

    return <>
        <div className="bg-tm-gray-100">
            <div className="p-6 grid grid-cols-12 gap-4">
                <div
                    className="text-lg leading-6 font-medium text-tm-gray-900 col-span-full">{translate('text.BasicInfo')}</div>

                <FieldsForm
                    includeFields={['LegalName', 'DBAName', 'ContactGroupID', 'OfficeID', 'UserDefinedField1', 'UserDefinedField2', 'Notes']}
                    onChange={handleInputChange}
                    fieldsState={fields}
                    isLoading={isLoading}
                    translate={translate}
                />
            </div>

            <div
                className="p-6 grid grid-cols-2 gap-4 border-t-2 border-tm-gray-300 mt-8 flex items-center justify-between gap-4">
                <div
                    className="text-lg leading-6 font-medium text-tm-gray-900 col-span-full mt-6">{translate('text.OrganizationInfo')}</div>

                <FieldsForm
                    includeFields={['AreaCode', 'PhoneNumber', 'PhoneExtension', 'PrimaryEmail', 'SCAC', 'OrganizationEntityTypeID', 'MCNumber', 'FFNumber', 'USDOTNumber', 'FederalID', 'NaicsID', 'SendPromotionalEmails']}
                    selects={selects}
                    onChange={handleInputChange}
                    fieldsState={fields}
                    isLoading={isLoading}
                    translate={translate}
                />
            </div>

            <div className="p-6 grid grid-cols-12 gap-4 pt-10 border-t-2 border-tm-gray-300 mt-4 ">
                <div
                    className="text-lg leading-6 font-medium text-tm-gray-900 col-span-full">
                    {translate('text.MailingAddress')}
                </div>

                <FieldsForm
                    includeFields={['CountryID', 'GooglePlaces', 'AddressName', 'AddressName2', 'CityName', 'StateID', 'PostalCode']}
                    onChange={handleInputChange}
                    fieldsState={fields}
                    isLoading={isLoading}
                    translate={translate}
                />
            </div>

            <div className="p-6 grid grid-cols-12 gap-4 pt-10 border-t-2 border-tm-gray-300 mt-8 pb-12">
                <div
                    className="text-lg leading-6 font-medium text-tm-gray-900 col-span-full">
                    {translate('text.PhysicalAddress')}
                </div>

                <FieldsForm
                    includeFields={['PhysicalSameAsMailingAddress', 'PhysicalCountryID', 'PhysicalGooglePlaces', 'PhysicalAddressName', 'PhysicalAddressName2', 'PhysicalCityName', 'PhysicalStateID', 'PhysicalPostalCode']}
                    selects={selects}
                    onChange={handleInputChange}
                    fieldsState={fields}
                    isLoading={isLoading}
                    translate={translate}
                />
            </div>
        </div>

        <GroupsViewDialog
            useInfoDialogResource={true}
            key={fields.ContactGroupID?.value?.value}
            groupID={fields.ContactGroupID?.value?.value}
            isGroupInfoDialogOpen={isGroupInfoDialogOpen}
            groupInfoData={groupInfoData}
            onClose={() => setIsGroupInfoDialogOpen(false)}
            translate={translate}
        />

        <div className="fixed top-full w-full">
            <ModalFooter
                buttonLabel={translate("btn.save")}
                buttonDisabled={!isStateDirty || isLoading}
                closeButtonDisabled={isLoading}
                onButtonClick={submit}
                onClose={onClose}
                closeButtonLabel={translate("btn.close")}
            />
        </div>
    </>
}